module.exports = __webpack_public_path__ + "img/product-points.b0748197.png";